import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "dateago",
  pure: true
})
export class DateagoPipe implements PipeTransform {
  // transform(value: any, args?: any): any {
  //   if (value) {
  //     console.log("🚀 ~ DateagoPipe ~ transform ~ value:", value)
  //     const seconds = Math.floor((+new Date() - +new Date(value)) / 1000);
  //     console.log("🚀 ~ DateagoPipe ~ transform ~ seconds:", seconds)
  //     if (seconds < 29){
  //       return "Just now";

  //     }
  //     const intervals = {
  //       year: 31536000,
  //       month: 2592000,
  //       week: 604800,
  //       day: 86400,
  //       hour: 3600,
  //       minute: 60,
  //       second: 1
  //     };
  //     let counter;
  //     for (const i in intervals) {
  //       counter = Math.floor(seconds / intervals[i]);
  //       if (counter > 0)
  //         if (counter === 1) {
  //           return counter + " " + i + " ago"; // singular (1 day ago)
  //         } else {
  //           return counter + " " + i + "s ago"; // plural (2 days ago)
  //         }
  //     }
  //     console.log(seconds,"seconds")
  //     return seconds + " seconds ago";

  //   }

  //   console.log(value,"value")
  //   return value;
  // }

  transform(value: any, args?: any): any {
    if (value) {
      const seconds = Math.floor((+new Date() - +new Date(value)) / 1000);
      if (seconds < 5) {
        return "Just now";
      }
      else if (seconds < 30) {
        return seconds + " secs ago";
      }
      else if (seconds < 60) {
        return seconds + " secs ago";
      } else if (seconds < 3600) {
        const minutes = Math.floor(seconds / 60);
        const remainingSeconds = seconds % 60;
        return minutes + " mins " + remainingSeconds + " secs ago";
      } else if (seconds < 86400) {
        const hours = Math.floor(seconds / 3600);
        const remainingMinutes = Math.floor((seconds % 3600) / 60);
        return hours + " hr " + remainingMinutes + " mins ago";
      } else if (seconds < 2592000) {
        const days = Math.floor(seconds / 86400);
        const remainingHours = Math.floor((seconds % 86400) / 3600);
        return days + " days " + remainingHours + " hrs ago";
      } else if (seconds < 31536000) {
        const months = Math.floor(seconds / 2592000);
        const remainingDays = Math.floor((seconds % 2592000) / 86400);
        return months + " months " + remainingDays + " days ago";
      } else {
        const years = Math.floor(seconds / 31536000);
        const remainingMonths = Math.floor((seconds % 31536000) / 2592000);
        return years + " years " + remainingMonths + " month ago";
      }
    }
    return value;
  }
}
